import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ConfirmationModalComponent } from '@app/modules/shared/confirmation-modal/confirmation-modal.component';
import { ContentLayoutComponent } from '@app/modules/shared/content-layout/content-layout.component';
import { SidePanelModule } from '@app/modules/side-panel/side-panel.module';
import { TypeaheadComponent } from '@app/modules/shared/typeahead/typeahead.component';
import { SpinnerComponent } from '@app/modules/shared/spinner/spinner.component';
import { ProductFilterComponent } from '@app/modules/shared/product-filter/product-filter.component';
import { ChartTableComponent } from '@app/modules/shared/chart-table/chart-table.component';
import { FormInputComponent } from './form-input/form-input.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TagInputModule } from 'ngx-chips';
import { FormTagsComponent } from './form-tags/form-tags.component';
import { TabButtonsComponent } from '@app/modules/shared/tab-buttons/tab-buttons.component';
import { AdvancedFilterComponent } from './advanced-filter/advanced-filter.component';
import { AdvancedFiltersAreaComponent } from './advanced-filters-area/advanced-filters-area.component';
import { UserSearchComponent } from './user-search/user-search.component';
import { ProductsListComponent } from './products-list/products-list.component';
import { ProductsListItemComponent } from './products-list-item/products-list-item.component';
import { CountryUnitsComponent } from './country-units/country-units.component';
import { CountryShipmentsComponent } from './country-shipments/country-shipments.component';
import { PipesModule } from '../pipes/pipes.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { SetComponentComponent } from './set-component/set-component.component';
import { DevPageComponent } from './developing/dev-page/dev-page.component';
import { ConfirmationModalFileComponent } from './confirmation-modal-file/confirmation-modal-file.component';
import { ModalEnableShipmentComponent } from './modal-enable-shipment/modal-enable-shipment.component';
import { PackagingConfirmationComponent } from './packaging-confirmation/packaging-confirmation.component';
import { CountryShipments2Component } from './country-shipments2/country-shipments2.component';
import { ProductsListsFoodComponent } from './products-lists-food/products-lists-food.component';
import { ProductsListsItemFoodComponent } from './products-lists-item-food/products-lists-item-food.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
    SidePanelModule,
    NgbModule,
    PipesModule,
    NgSelectModule,
    TagInputModule
  ],
  declarations: [
    ConfirmationModalComponent,
    ContentLayoutComponent,
    TypeaheadComponent,
    CountryShipmentsComponent,
    TabButtonsComponent,
    ProductFilterComponent,
    SpinnerComponent,
    ChartTableComponent,
    FormInputComponent,
    FormTagsComponent,
    AdvancedFilterComponent,
    AdvancedFiltersAreaComponent,
    UserSearchComponent,
    ProductsListComponent,
    ProductsListItemComponent,
    CountryUnitsComponent,
    SetComponentComponent,
    DevPageComponent,
    ConfirmationModalFileComponent,
    ModalEnableShipmentComponent,
    PackagingConfirmationComponent,
    CountryShipments2Component,
    ProductsListsFoodComponent,
    ProductsListsItemFoodComponent
  ],
  entryComponents: [ConfirmationModalComponent, ConfirmationModalFileComponent, ModalEnableShipmentComponent, AdvancedFilterComponent, PackagingConfirmationComponent],
  exports: [
    ConfirmationModalComponent,
    ConfirmationModalFileComponent,
    ContentLayoutComponent,
    TypeaheadComponent,
    ProductFilterComponent,
    SpinnerComponent,
    ChartTableComponent,
    TabButtonsComponent,
    FormInputComponent,
    CountryShipmentsComponent,
    FormTagsComponent,
    AdvancedFiltersAreaComponent,
    UserSearchComponent,
    ProductsListComponent,
    CountryUnitsComponent,
    ProductsListItemComponent,
    SetComponentComponent,
    DevPageComponent,
    PackagingConfirmationComponent,
    CountryShipments2Component,
    ProductsListsFoodComponent,
    ProductsListsItemFoodComponent
  ]
})
export class SharedModule { }
